import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import Translate from "../../utils/Translate";
import { getCurrentDateMask, getCurrentInputFormat, isValidDate } from "../../utils/dateTimeFormat";
import { useCallback, useState } from "react";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { DatePicker } from "@mui/x-date-pickers";
import { useApi } from "../../utils/Api";
import { accessKeys, hasSomeAccess } from "../../utils/userAccess";

const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));

export default function OrderScheduleForInvoiceDialog({ currentScheduledInvoiceDate, orderId, onClose }) {
  const [scheduledInvoiceDate, setScheduledInvoiceDate] = useState(
    currentScheduledInvoiceDate ? new Date(currentScheduledInvoiceDate) : null,
  );
  const api = useApi();

  const scheduleInvoiceOrder = useCallback(
    async (orderId, scheduledInvoiceDate) => {
      const response = await api.fetch(
        `${import.meta.env.VITE_MAIN_URL}orders/${orderId}/invoice/schedule`,
        { scheduledInvoiceDate },
        "POST",
      );

      if (response.isSuccessful) {
        onClose(true);
      }
    },
    [api],
  );

  return (
    <Dialog open onClose={onClose} maxWidth={false} className="smallCourseDialog" scroll="paper">
      <DialogTitle>{Translate.get("ScheduleInvoice")}</DialogTitle>
      <DialogContent>
        <DatePicker
          displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
          sx={{ width: "100%", marginTop: "6px" }}
          format={getCurrentInputFormat()}
          mask={getCurrentDateMask()}
          label={Translate.get("Date")}
          value={scheduledInvoiceDate ?? ""}
          minDate={tomorrow}
          onChange={(newValue) => {
            if (isValidDate(newValue) || !newValue) {
              setScheduledInvoiceDate(newValue ? newValue : null);
            }
          }}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>{Translate.get("Cancel")}</Button>
        <ButtonWithSpinner
          variant="contained"
          onClick={async () => scheduleInvoiceOrder(orderId, scheduledInvoiceDate)}
        >
          {Translate.get("Save")}
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
}
